var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2396 12.1141C14.5608 11.7929 14.5608 11.2741 14.2396 10.9529L10.4596 7.17295C10.1384 6.85177 9.61959 6.85177 9.29841 7.17295L5.51841 10.9529C5.19723 11.2741 5.19723 11.7929 5.51841 12.1141C5.83959 12.4353 6.35841 12.4353 6.67959 12.1141L9.88312 8.91883L13.0784 12.1141C13.3996 12.4353 13.9266 12.4271 14.2396 12.1141Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52604 15.8859C5.20486 16.2071 5.20486 16.7259 5.52604 17.0471L9.30604 20.827C9.62721 21.1482 10.146 21.1482 10.4672 20.827L14.2472 17.0471C14.5684 16.7259 14.5684 16.2071 14.2472 15.8859C13.926 15.5647 13.4072 15.5647 13.086 15.8859L9.88251 19.0812L6.68721 15.8859C6.36604 15.5647 5.83898 15.5729 5.52604 15.8859Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySelect);
export default __webpack_public_path__ + "static/media/company_select.eebd8161.svg";
export { ForwardRef as ReactComponent };